import React from "react";
const SwiperLeft = () => (
  <svg width="16" height="28" viewBox="0 0 16 28"  xmlns="http://www.w3.org/2000/svg">
  <path d="M16.0003 2.4615L13.5388 0L0.000560682 13.5382L0.11857 13.6562L0 13.7748L13.5382 27.3131L15.9997 24.8516L4.80499 13.6568L16.0003 2.4615Z"/>
  </svg>
  
);
export default SwiperLeft;
